/**
 * Parses a string as an actual Document.
 * @param markup Markup to turn into a document.
 */
export function parseString(markup: string): Document {
	const parser = new DOMParser()
	const rawContent = parser.parseFromString(markup, 'text/html')
	return rawContent
}
